import { userSubscriptionLevel } from '@modules/auth/types'
import { FEATURE_FLAGS_CONFIG } from '@modules/config/feature-flag-config'
import { useUserConfig } from '@modules/config/hooks/useUserConfig'
import { FeatureFlagConfig } from '@modules/config/types'

export const useFeatureFlags = () => {
  const { featureFlags } = useUserConfig()

  return (featureFlags || FEATURE_FLAGS_CONFIG[userSubscriptionLevel.SUBSCRIBED_USER]) as FeatureFlagConfig
}
